import { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
  Grid, TextField, MenuItem, Button,
  Typography, FormGroup, FormControlLabel, CircularProgress, Autocomplete, InputAdornment
} from "@mui/material";
import { LocalTaxiRounded, ScheduleRounded, ChecklistRtlRounded, Search as SearchIcon } from "@mui/icons-material";
import { useMapsLibrary } from '@vis.gl/react-google-maps';
import CustomSwitch from "SharedComponents/CustomSwitch";
import { useFormik, useField } from "formik";
import * as yup from "yup";
import Assigndriver from "./Assigndriver";
// Redux
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";

//Services
import DispatcherApi from "Services/Dispatcher";
import { getCountryCodes } from "Utils/country";

const CreateTrip = ({
  destination, dropLatLng, pickupLatLng, distance, travelDuration, origin,
  activecarouselRef, userType, subcmpnyName, toggleDrawer
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const demoaccount_id = useSelector((state) => state?.AuthReducer?.demoaccount_id || "");
  const [autoassign, setAutoassign] = useState(false);
  const [assigndriverModal, setAssigndriverModal] = useState(false);
  const [dialogFormValues, setDialogFormValues] = useState({});
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [loadingCountries, setLoadingCountries] = useState(true);
  const [countrySearch, setCountrySearch] = useState("");

  // Fetch country codes from API
  useEffect(() => {
    const fetchCountryCodes = async () => {
      try {
        const countries = getCountryCodes();
        setCountryCodeData(countries);
        setLoadingCountries(false);
      } catch (error) {
        console.error('Error fetching country codes:', error);
        setLoadingCountries(false);
      }
    };

    fetchCountryCodes();
  }, [])

  const handleautoassign = () => {
    setAutoassign((prev) => !prev);
  };

  const handleCloseassignModal = () => {
    setAssigndriverModal(false);
  };

  const handledisagreeassignModal = () => {
    setAssigndriverModal(false);
  }

  const closedrawer = () => {
    toggleDrawer('right', false);
    // console.log("click")
  }

  const handlecreatetrip = (formValues) => {
    formValues.bookingType = "USER";
    formValues.d_address = destination;
    formValues.d_latitude = dropLatLng.lat;
    formValues.d_longitude = dropLatLng.lng;
    formValues.distance = distance;
    formValues.minutes = travelDuration;
    formValues.s_address = origin;
    formValues.s_latitude = pickupLatLng.lat;
    formValues.s_longitude = pickupLatLng.lng;
    formValues.service_type = activecarouselRef.current?.service_id;
    formValues.estimatedFare = activecarouselRef.current?.estimated_fare;
    formValues.autoassigndriver = autoassign;
    formValues.userType = userType;
    formValues.subcmpnyName = subcmpnyName;
    formValues.demoaccount_id = demoaccount_id;
     formValues.isScheduled = formValues.isScheduled;
    formValues.scheduledTime = formValues.scheduledTime;

    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Ride created successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik.resetForm();
        navigate('/triplist');
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while creating ride",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      formik.resetForm();
      const pickupInput = document.getElementById("pickuplocation");
      const dropInput = document.getElementById("droplocation");

      if (pickupInput) {
        pickupInput.value = "";
      }

      if (dropInput) {
        dropInput.value = "";
      }
    };
    if (formValues.autoassigndriver) {
      DispatcherApi.createridebydispatcher({ ...formValues }).then(onSuccess, onFailure);
    }
    else {
      setDialogFormValues(formValues);
      setAssigndriverModal(true);
    }
  };

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
      promo_code: "",
      provider_id: "",
      service_type: "",
      s_latitude: "",
      s_longitude: "",
      s_address: "",
      d_latitude: "",
      d_longitude: "",
      d_address: "",
      distance: "",
      minutes: "",
      bookingType: "",
      userNotes: "",
      countryCode: "",
      isScheduled: false,
      scheduledTime: "",
    },
    validationSchema: yup.object({
      first_name: yup.string().required("First Name is required").nullable(),
      countryCode: yup.string().required("Country Code is required").nullable(),
      email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required")
        .nullable(),
      mobile: yup
        .string()
        .matches(/^\d{1,15}$/, "Invalid mobile number")
        .required("Mobile Number is required")
        .nullable(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      handlecreatetrip(values);
    },
  });

  useEffect(() => {
  if (formik.values.isScheduled) {
    setAutoassign(true);
  }else{  
    setAutoassign(false);

  }
  console.log(autoassign);
}, [formik.values.isScheduled]);

  const roundedInputStyle = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "25px",
      backgroundColor: "#f5f5f5"
    },
  };

  return (
    <>
      <Grid container rowSpacing={1} className={classes.containerformik} >

        
        <Grid item xs={12} className={classes.switchWrapper}>
          <Grid item lg={5}>

            <Typography variant="body1">
              Schedule Ride
            </Typography>
          </Grid>
          <Grid item lg={7}>

            <FormControlLabel
              control={
                <CustomSwitch
                  checked={formik.values.isScheduled}
                  onChange={(e) => formik.setFieldValue("isScheduled", e.target.checked)}
                />
              }
            />
          </Grid>
        </Grid>

        {formik.values.isScheduled && (
          <Grid item xs={12} className={classes.formikgrids}>
            <TextField
              id="scheduledTime"
              label="Schedule Date & Time"
              type="datetime-local"
              value={formik.values.scheduledTime}
              onChange={formik.handleChange}
              fullWidth
              variant="standard"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        )}

        <Grid item xs={6} className={classes.formikgrids} >
          <Typography
            variant="body2"
            sx={{
              fontWeight: 500,
              marginBottom: "6px",
              color: "#374151",   // soft dark gray
            }}
          >
            First Name
          </Typography>
          <TextField
            inputProps={{
              disableUnderline: false,
              form: {
                autocomplete: 'off',
              },
            }}
            id="first_name"
            label="First Name"
            value={formik?.values?.first_name}
            defaultValue={formik?.values?.first_name}
            onChange={formik.handleChange}
            error={
              formik?.errors?.first_name &&
              formik?.touched?.first_name
            }
            helperText={
              formik?.errors?.first_name &&
              formik?.touched?.first_name &&
              formik?.errors?.first_name
            }
            sx={roundedInputStyle}
            fullWidth
            variant="outlined"
            size="small"
          ></TextField>
        </Grid>
        <Grid item xs={6} className={classes.formikgrids}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 500,
              marginBottom: "6px",
              color: "#374151",   // soft dark gray
            }}
          >
            Last Name
          </Typography>
          <TextField
            inputProps={{
              disableUnderline: false,
              form: {
                autocomplete: 'off',
              },
            }}
            id="last_name"
            label="Last Name"
            value={formik?.values?.last_name}
            defaultValue={formik?.values?.last_name}
            onChange={formik.handleChange}
            error={
              formik?.errors?.last_name &&
              formik?.touched?.last_name
            }
            helperText={
              formik?.errors?.last_name &&
              formik?.touched?.last_name &&
              formik?.errors?.last_name
            }
            sx={roundedInputStyle}
            fullWidth
            variant="outlined"
            size="small"
          ></TextField>
        </Grid>
        <Grid item xs={12} className={classes.formikgrids} >
          <Typography
            variant="body2"
            sx={{
              fontWeight: 500,
              marginBottom: "6px",
              color: "#374151",   // soft dark gray
            }}
          >
            Email <img
              src="/assets/images/DispatcherIcons/Email.png"
              alt="email"
              width="20"
              style={{ pointerEvents: "none" }}
            />
          </Typography>
          <TextField
            inputProps={{
              disableUnderline: false,
              form: {
                autocomplete: 'off',
              },
            }}
            id="email"
            label="Email"
            value={formik?.values?.email}
            defaultValue={formik?.values?.email}
            onChange={formik.handleChange}
            error={
              formik?.errors?.email &&
              formik?.touched?.email
            }
            helperText={
              formik?.errors?.email &&
              formik?.touched?.email &&
              formik?.errors?.email
            }
            sx={roundedInputStyle}
            fullWidth
            variant="outlined"
            size="small"
          ></TextField>
        </Grid>
        <Grid item xs={12} className={classes.formikgrids}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 500,
              marginBottom: "6px",
              color: "#374151",   // soft dark gray
            }}
          >
            Country Code
          </Typography>
          {loadingCountries ? (
            <CircularProgress size={24} />
          ) : (
            <TextField
              name="countryCode"
              id="countryCode"
              select
              value={formik?.values?.countryCode || ""}
              onChange={formik?.handleChange}
              error={
                formik?.errors?.countryCode &&
                formik?.touched?.countryCode
              }
              helperText={
                formik?.errors?.countryCode &&
                formik?.touched?.countryCode &&
                formik?.errors?.countryCode
              }
              sx={roundedInputStyle}
              fullWidth
              variant="outlined"
              size="small"
              SelectProps={{
                displayEmpty: true,
                MenuProps: {
                  autoFocus: false,
                },
              }}
            >
              <MenuItem
                value=""
                disabled
                sx={{ display: "none" }}
              >
                Select Country Code
              </MenuItem>

              <div style={{ padding: "8px", position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>
                <TextField
                  autoFocus
                  size="small"
                  placeholder="Search country..."
                  fullWidth
                  value={countrySearch}
                  onChange={(e) => setCountrySearch(e.target.value)}
                  onClick={(e) => {
                    // Prevent the Select dropdown from closing when clicking inside
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => {
                    // Prevent the Select dropdown from closing when typing space and bubbling
                    e.stopPropagation();
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              {countryCodeData
                .filter((country) =>
                  country.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
                  country.code.toLowerCase().includes(countrySearch.toLowerCase()) ||
                  country.dial_code.toLowerCase().includes(countrySearch.toLowerCase())
                )
                .map((country) => (
                  <MenuItem
                    key={country.code}
                    value={country.dial_code}
                  >
                    {`${country.dial_code} ${country.name}`}
                  </MenuItem>
                ))}
            </TextField>
          )}
        </Grid>
        <Grid item xs={12} className={classes.formikgrids}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 500,
              marginBottom: "6px",
              color: "#374151",   // soft dark gray
            }}
          >
            Mobile Number <img
              src="/assets/images/DispatcherIcons/MobileNumber.png"
              alt="No"
              width="20"
              style={{ pointerEvents: "none" }}
            />
          </Typography>
          <TextField
            inputProps={{
              disableUnderline: false,
              form: {
                autocomplete: 'off',
              },
            }}
            id="mobile"
            label="Mobile"
            value={formik?.values?.mobile}
            defaultValue={formik?.values?.mobile}
            onChange={formik.handleChange}
            error={
              formik?.errors?.mobile &&
              formik?.touched?.mobile
            }
            helperText={
              formik?.errors?.mobile &&
              formik?.touched?.mobile &&
              formik?.errors?.mobile
            }
            sx={roundedInputStyle}
            fullWidth
            variant="outlined"
            size="small"
          ></TextField>
        </Grid>
        <Grid item xs={12} className={classes.formikgrids}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 500,
              marginBottom: "6px",
              color: "#374151",   // soft dark gray
            }}
          >
            User Notes <img
              src="/assets/images/DispatcherIcons/UserNotes.png"
              alt="Notes"
              width="20"
              style={{ pointerEvents: "none" }}
            />
          </Typography>
          <TextField
            inputProps={{
              disableUnderline: false,
              form: {
                autocomplete: 'off',
              },
            }}
            multiline
            rows={4}
            id="userNotes"
            label="User Notes"
            value={formik?.values?.userNotes}
            defaultValue={formik?.values?.userNotes}
            onChange={formik.handleChange}
            error={
              formik?.errors?.userNotes &&
              formik?.touched?.userNotes
            }
            helperText={
              formik?.errors?.userNotes &&
              formik?.touched?.userNotes &&
              formik?.errors?.userNotes
            }
            sx={roundedInputStyle}
            fullWidth
            variant="outlined"
            size="small"
          ></TextField>
        </Grid>
        <Grid item xs={12} className={classes.switchWrapper}>
          <span style={{ marginRight: "10px" }}>
            Auto-assign driver
          </span>
          <FormControlLabel
            control={
              <CustomSwitch
                checked={autoassign}
                onChange={() => handleautoassign()}
                 disabled={formik.values.isScheduled}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#22c55e", // thumb green
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "rgba(34,197,94,0.5)", // track green
                    opacity: 1,
                  },
                  "& .MuiSwitch-switchBase": {
                    color: "#ef4444", // thumb red (OFF)
                  },
                  "& .MuiSwitch-track": {
                    backgroundColor: "rgba(239,68,68,0.5)", // track red (OFF)
                    opacity: 1,
                  },
                }}
              />
            }
          />
        </Grid>

        <Grid item xs={12} className={classes.switchWrapper} >
          <Button
            variant="contained"
            onClick={formik?.handleSubmit}
            sx={{
              padding: "3px 25px",
              borderRadius: "25px",
              fontSize: "11px",
              backgroundColor: "#22c55e",
              "&:hover": {
                backgroundColor: "#0cd957",
              }
            }}
          >
            Create trip
          </Button>
          <Button
            variant="contained"
            onClick={closedrawer}
            sx={{
              // marginLeft:"1%",
              padding: "3px 50px",
              borderRadius: "25px",
              fontSize: "11px",
              backgroundColor: "#ef4444",
              "&:hover": {
                backgroundColor: "#da0f0f",
              }
            }}
          >
            Close
          </Button>
        </Grid>

        <Assigndriver
          userType={userType}
          subcmpnyName={subcmpnyName}
          openDialog={assigndriverModal}
          formvalues={dialogFormValues}
          handleClose={handleCloseassignModal}
          handledisagree={handledisagreeassignModal}
        ></Assigndriver>

      </Grid>
    </>
  );
};

export default CreateTrip;
